import './App.css';
import Header from "./componentes/Header.js";
import {BrowserRouter as Router,Routes, Route, BrowserRouter,} from "react-router-dom";
import Bases from './componentes/Bases';
import Galeria from './componentes/Galeria';
import Home from './componentes/Home';
import Registro from './componentes/Registro';
function App() {
  return (
    <div className="App ">
      <BrowserRouter basename={'/Arbolitos2025/'}>
      {/*<BrowserRouter>*/}
      <Header />
      <Routes exact path='/'>
          <Route exact path='/' element={<Home/>}/>
          <Route exact path='/bases' element={<Bases/>} />
          <Route exact path='/galeria' element={<Galeria/>}/>
          <Route exact path='/registro' element={<Registro/>}/>  
      </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
